<template>
  <div class="bg">
    <div class="animated flipInY">
      <div class="logintitle">
        <span>青浦科技数字化网站</span>
      </div>
      <el-form
        :model="loginForm"
        :rules="fieldRules"
        ref="loginForm"
        label-position="left"
        label-width="0px"
        class="login-container"
      >
        <div class="logtit">
          <span>账号登陆</span>
        </div>
        <el-form-item prop="account">
          <el-input
            type="text"
            v-model="loginForm.account"
            auto-complete="off"
            placeholder="输入账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            auto-complete="off"
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item>
                    <el-row type="flex" justify="space-between">
                        <el-checkbox>记住密码</el-checkbox>
                        <a  @click="forget">忘记密码</a>
                    </el-row>
        </el-form-item>-->
        <el-form-item>
          <el-button
            type="primary"
            @click.native.prevent="login"
            :loading="logining"
            >登 录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logining: false,
      loginForm: {
        account: "",
        password: "",
      },
      fieldRules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      checked: true,
    };
  },
  mounted() {},
  methods: {
    login() {
      if (!this.loginForm.account) {
        this.$message.warning("请输入账号！");
        return;
      } else if (!this.loginForm.password) {
        this.$message.warning("请输入密码！");
        return;
      }
      this.logining = true;
      let userInfo = {
        account: this.loginForm.account,
        password: this.loginForm.password,
      };
      // 提取菜单数组，交给本地存储
      sessionStorage.userInfo = JSON.stringify(userInfo);
      sessionStorage.setItem("username", 1);
      this.$router.push("/Home"); // 登录成功，跳转到主页
      //   let data = this.$qs.stringify({
      //     user: this.loginForm.account, //用户名
      //     pwd: this.loginForm.password //密码
      //   });
      // console.log(data)
      // this.$axios({
      //   method: "post",
      //   url: "/zbgl/login",
      //   data: data
      // })
      //   .then(res => {
      //     if(res.data.code == 200){
      //       if(res.data.msg=='登陆成功'){
      //           this.$router.push("/Home"); // 登录成功，跳转到主页
      //       }
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // this.$router.push("/Home"); // 登录成功，跳转到主页
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../../assets/images/beijing.png");
  background-size: cover;
  background-position: -1%;
  .login-container {
    width: 35vw;
    height: 46vh;
    border-radius: 5px;
    padding: 20px;
    z-index: 3;
    margin-right: -37%;
    background: rgba(9, 42, 84, 0.7);
    border: 1px solid rgba(47, 129, 232, 0.8);
    box-shadow: 0 2px 15px 0 rgba(57, 136, 236, 0.2);
    border-radius: 6px;
  }
  .logtit {
    height: 10vh;
    font-family: PingFangSC-Medium;
    font-size: 1.4rem;
    color: #e0eeff;
    letter-spacing: 2px;
    text-align: center;
  }
  .el-form-item {
    width: 28vw;
    margin: 0 auto;
    margin-bottom: 25px !important;
  }
  form {
    margin-top: 10vh;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
  a {
    text-decoration: none;
    color: #606266;
  }
  button {
    width: 100%;
    font-weight: 600;
  }
  .flipInY {
    height: 65vh;
  }
  .logintitle {
    font-family: PingFangSC-Medium;
    font-size: 2rem;
    color: #e0eeff;
    letter-spacing: -0.51px;
    text-align: center;
    text-shadow: 0 2px 10px rgba(47, 129, 232, 0.1);
  }
}
</style>
